export const videoPlayerModel = (id: string) => ({
  id,
  type: 'VideoPlayer',
  label: 'Video player',
  properties: [
    {
      name: 'styles',
      label: 'Styles',
      control: 'TitleDivider',
      value: '',
      __typename: 'ComponentProperty',
    },
    {
      name: 'header',
      label: 'Text',
      control: 'VariableTextInput',
      value: 'My Awesome Video',
      __typename: 'ComponentProperty',
    },
    {
      name: 'url',
      label: 'Video url',
      control: 'VariableTextInput',
      value: '',
      __typename: 'ComponentProperty',
    },
    {
      name: 'padding_8px_1',
      label: '',
      control: 'PaddingControl8px',
      value: '',
      __typename: 'ComponentProperty',
    },
    {
      name: 'paddings',
      label: 'Padding',
      control: 'TitleDividerNoLine',
      value: '',
      __typename: 'ComponentProperty',
    },
    {
      name: 'paddingTop',
      label: 'Top',
      control: 'Slider',
      value: '20',
      __typename: 'ComponentProperty',
    },
    {
      name: 'paddingBottom',
      label: 'Bottom',
      control: 'Slider',
      value: '20',
      __typename: 'ComponentProperty',
    },
    {
      name: 'paddingLeft',
      label: 'Left',
      control: 'Slider',
      value: '20',
      __typename: 'ComponentProperty',
    },
    {
      name: 'paddingRight',
      label: 'Right',
      control: 'Slider',
      value: '0',
      __typename: 'ComponentProperty',
    },
  ],
  __typename: 'Component',
});
